/**
 * Infinite Scroll jQuery Plugin
 */
(function($) {
   /**
   
   EXAMPLE:

   var jContent = $("#myScrollableRegion").infitescroll({
      triggerAt: 150,
      page: 1,
      dataHandler: function(infiniteScroll) {
         $.ajax({
            url: "/somepage.php",
            data: {
               page: infiniteScroll.page
            },
            dataType: "html",
            success: function(data) {
               if (data == "") {
                  infiniteScroll.setReachedEnd();
               } else {
                  jContent.append(data);
                  infiniteScroll.reset();
               }
            }
         });
      }
   });

   */

   $.fn.infinitescroll = function(options) {
      return $(this).each(function() {
         var m_this = $(this),

            m_settings = $.extend({
               // Number of pixels from the bottom of the page
               // at which to retrieve the next page
               triggerAt: 300,

               // The first page to request
               page: 2,

               // Function to call to retrieve data
               dataHandler: function() {
                  // Placeholder
               }
            }, options),

            m_bInProgress = false,
            m_bMaxReached = false,

            infinityRunner = function() {
               if (m_settings.force || (m_settings.triggerAt >= (m_this[0].scrollHeight - m_this.height() - m_this.scrollTop()))) {
                  m_settings.force = false;

                  // if the request is in progress, exit and wait for it to finish
                  m_bInProgress = true;

                  m_settings.dataHandler({
                     setReachedEnd: function() {
                        m_bMaxReached = true;
                     },

                     reset: function() {
                        m_settings.page++;
                        m_bInProgress = false;
                     },

                     page: m_settings.page
                  });
               }
            };

         m_this.bind('scrollpage', function(e, page) {
            if (m_bInProgress) return;
            if (m_bMaxReached) return;

            m_settings.page = page;
            m_settings.force = true;
            infinityRunner();
         });

         m_this.unbind('.infinitescroll').bind('scroll.infinitescroll', function(e) {
            if (m_bInProgress) return;
            if (!m_bMaxReached) {
               infinityRunner();
            }
         });

         // Test initial page layout for trigger
         infinityRunner();
      });
   };
})(jQuery);
